export default {
  "widget.defaultTitle": "Fale connosco",
  "widget.defaultSubtitle": "Estamos aqui para ajudar",
  "widget.defaultGreeting": "Olá! Como podemos ajudá-lo hoje?",
  "chat.close": "Fechar chat",
  "chat.open": "Abrir chat",
  "chat.expand": "Expandir chat",
  "chat.collapse": "Recolher chat",
  "chat.conversationEnded": "Esta conversa foi encerrada",
  "chat.startNew": "Iniciar Nova Conversa",
  "chat.poweredBy": "Desenvolvido por",
  "chat.conversationClosed": "Conversa Encerrada",
  "chat.aiLabel": "Assistente de IA",
  "input.placeholder": "Escreva uma mensagem...",
  "input.send": "Enviar mensagem",
  "error.sendFailed": "Não foi possível enviar a sua mensagem. Tente novamente dentro de momentos.",
  "error.messageTooLong": "A sua mensagem é demasiado longa. Encurte-a e tente novamente.",
  "chat.teamMember": "Um membro da equipa",
  "chat.agentJoined": "{name} entrou na conversa",
  "chat.agentLeft": "{name} saiu da conversa",
  "chat.agentReturnedToAi":
    "{name} saiu da conversa. Está novamente a falar com o assistente de IA.",
  "availability.open": "Aberto agora",
  "availability.backAt": "Regresso: {when}",
  "availability.closed": "Fora do horário agora",
  "waiting.title": "À espera de uma pessoa",
  "waiting.typical": "Costuma responder em {time}",
  "waiting.alerted": "Avisámos a equipa.",
  "waiting.closed": "A equipa regressa {when}. Até lá, o assistente de IA pode continuar a ajudar.",
  "waiting.minutes": "~{n} min",
  "waiting.hours": "~{n} h",
  "contact.prompt":
    "Deixe o seu e-mail e enviaremos a resposta da equipa para lá se já tiver saído.",
  "contact.label": "E-mail",
  "contact.placeholder": "voce@exemplo.com",
  "contact.submit": "Avisem-me",
  "contact.consent": "Usaremos o seu e-mail apenas para responder a esta conversa.",
  "contact.saved": "Obrigado! Se já tiver saído quando a equipa responder, enviaremos um e-mail.",
  "contact.failed": "Não foi possível guardar o seu e-mail. Verifique e tente novamente.",
  "input.attach": "Anexar fotografia ou PDF",
  "error.fileTooLarge": "Esse ficheiro é demasiado grande. Fotografias e PDFs até 10 MB.",
  "error.fileType": "Pode enviar fotografias (JPG, PNG, GIF, WebP) ou PDFs.",
  "error.fileFailed": "Não foi possível enviar o seu ficheiro. Tente outro.",
  "attachment.photo": "Fotografia",
  "attachment.file": "Ficheiro",
  "attachment.sending": "A enviar...",
  "error.verificationFailed": "Não foi possível verificar a sua mensagem. Atualize a página e tente novamente.",
  "challenge.label": "Verificação de segurança",
  "challenge.prompt": "Uma verificação rápida de segurança antes de enviarmos a sua mensagem.",
  "csat.defaultQuestion": "Como avalia o apoio que recebeu hoje?",
  "csat.thankYou": "Obrigado pelo seu feedback!",
} as const;
